var _style, _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGameFav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "-29 -29 300 300"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.1,
    cy: 117.1,
    r: 110,
    stroke: "#fff",
    strokeWidth: 6.5,
    strokeMiterlimit: 8.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart_outter",
    className: "st1",
    d: "M145.9 62.1c20.9 0 37.3 16 37.3 36.4 0 25.2-23.8 47.8-55 74.7l-8.7 8.1c-.5.5-1.2.7-1.9.7s-1.3-.2-1.9-.7l-8.8-8.2-6-5.2C72.8 143.3 52 122.1 52 98.5c0-20.4 16.4-36.4 37.3-36.4 14.4 0 21.7 6.9 28.3 14.3l1.6-1.8c6.2-6.6 13.5-12.5 26.7-12.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "heart_inner",
    d: "M145.9 67.6c-13.4 0-19.3 6.9-26.2 14.8-1 1.2-3.1 1.2-4.1 0l-2.5-2.9c-5.9-6.6-12-11.9-23.7-11.9-17.8 0-31.8 13.6-31.8 30.9 0 22.9 23 44.6 53 70.5l7 6.6 6.9-6.5 5.8-5c27.2-23.8 47.3-44.1 47.3-65.5.1-17.3-13.8-31-31.7-31z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "star",
    className: "st1",
    d: "M118.7 95.1l4.9 14.6c.1.3.4.6.8.6h15.7c1.1 0 1.5 1.3.6 2l-12.7 9c-.2.1-.4.4-.4.7v.1l4.9 14.7c.3 1-.8 1.8-1.7 1.2l-12.7-9c-.3-.2-.7-.2-1 0l-12.7 9c-.9.6-2.1-.2-1.7-1.2l4.9-14.6v-.2c0-.3-.1-.5-.4-.7l-12.7-9c-.9-.6-.4-2 .6-2h15.7c.4 0 .7-.2.8-.6l4.9-14.6c.4-1 1.9-1 2.2 0z"
  })));
}

SvgGameFav.displayName = 'GameFav';
export default SvgGameFav;